module.exports = __webpack_public_path__ + "img/1.d8e269d7.jpg";